import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
	providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
	constructor(
		protected authService: AuthService,
		private router: Router,
	) {}

	/**
	 * Protege las rutas públicas de usuarios autenticados.
	 * Redirige a una ruta protegida si el usuario está autenticado.
	 */
	canActivate(): boolean {
		if (this.authService.isAuthenticated()) {
			this.router.navigate(['/backoffice/dashboard']);
			return false;
		}

		return true;
	}
}
